import { Editor, EditorContent } from '@tiptap/react';
import { ReactNode } from 'react';

import { clstx } from '@payaca/utilities/cvaMerge';

import EditorBubbleMenu from './EditorBubbleMenu';
import EditorToolbar from './EditorToolbar';
import { type EditorToolbarItem } from './editorActions';

interface EditorShellProps {
  editor: Editor | null;
  readOnly: boolean;
  toolbar: EditorToolbarItem[] | false;
  borderless?: boolean;
  /**
   * Optional sidebar rendered alongside the editor (e.g. RichTextarea's
   * variable picker). Only shown when not readOnly.
   */
  sidebar?: ReactNode;
}

const EditorShell = ({
  editor,
  readOnly,
  toolbar,
  borderless = false,
  sidebar,
}: EditorShellProps) => {
  if (borderless) {
    return (
      <>
        <EditorContent editor={editor} />
        {editor && !readOnly && toolbar !== false && (
          <EditorBubbleMenu editor={editor} items={toolbar} />
        )}
      </>
    );
  }

  const hasSidebar = !!sidebar && !readOnly;
  return (
    <div className={hasSidebar ? 'gap-5 md:flex' : undefined}>
      <div
        className={clstx(
          !readOnly && 'overflow-hidden rounded-xl border border-gray-200',
          hasSidebar ? 'md:w-3/4' : 'w-full'
        )}
      >
        {editor && !readOnly && toolbar !== false && (
          <EditorToolbar editor={editor} items={toolbar} />
        )}
        <EditorContent editor={editor} />
      </div>
      {hasSidebar && sidebar}
    </div>
  );
};

export default EditorShell;
